import React, { ReactNode, ComponentType } from 'react';
import { Button } from '@framework-controls/core';
import { ReactComponent as IconRightArrow } from 'src/content/icons/RightArrow.svg';
import * as css from './LandingButton.module.scss';

interface IProps {
    header: string;
    message: ReactNode;
    iconName: ComponentType;
    handler: (event: any) => void;
    title: string;
    id: string;
    lastFlag: boolean;
    theme: string;
}

const LandingButton = (props: IProps) => {
    let btnClassName = css.button;
    if (props.lastFlag) {
        btnClassName = css.lastBtn;
    }
    if (props.theme === 'ford' && props.lastFlag) {
        btnClassName = css.fordLastBtn;
    }

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'btn'}
                variant={'landingButton'}
                type={'custom'}
                tooltip={props.title}
                onClick={props.handler}>
                <div className={css.iconBorder}>
                    <span className={css.icon}>
                        <props.iconName />
                    </span>
                </div>
                <div className={css.btnTextContent}>
                    <div className={css.btnHeadingText}>{props.header}</div>
                    <small className={css.small}>
                        {props.message}
                    </small>
                </div>
                <div className={css.arrowIcon}>
                    <IconRightArrow className={css.arrowIcon2} />
                </div>
            </Button>
        </div>
    );
};

export default LandingButton;
